export enum TicketsPageSize {
    full = 'full',
    compact = 'compact',
    onlyCheckout = 'onlyCheckout',
}

export enum CustomerPurchaseFlowTicketsPage {
    full = '/tickets',
    compact = '/ticketsCompactSize',
    onlyCheckout = '/onlyCheckout',
    reservedSeating = '/reservedTickets',
    series = '/series',
    seriesTickets = '/series/tickets', // [infinite series calendar] tickets page rendered in tickets section
    waitingRoom = '/waitingRoom',
}
